import { Link } from 'react-router-dom';
import { useAuthStore } from '../../store/auth-store';
import { PageHeader } from '../../components/page-header';

export function SettingsPage() {
  const session = useAuthStore((s) => s.session);

  return (
    <div className="max-w-3xl space-y-6">
      <PageHeader title="Settings" />

      <section className="panel p-6">
        <h2 className="mb-1.5 text-[16px] font-semibold text-ink-900">Two-factor authentication</h2>
        <p className="mb-4 text-[13.5px] text-ink-700">
          Admin accounts sign in with a 6-digit code from an authenticator app unless a super admin
          has turned two-factor off for the account (Admin management). Enrol once and you'll be
          prompted for the code on every sign-in from then on.
        </p>
        <Link to="/2fa-setup" className="btn btn-primary">
          Set up two-factor auth
        </Link>
      </section>

      <section className="panel p-6">
        <h2 className="mb-3 text-[16px] font-semibold text-ink-900">Account</h2>
        <dl className="grid grid-cols-[auto_1fr] gap-x-6 gap-y-2 text-[14px]">
          <dt className="text-ink-500">Role</dt>
          <dd className="text-ink-900">{session?.role ?? '—'}</dd>
          <dt className="text-ink-500">Scopes</dt>
          <dd className="text-ink-900">
            {session?.scope?.length ? `${session.scope.length} permissions` : '—'}
          </dd>
          <dt className="text-ink-500">Session expires</dt>
          <dd className="font-tabular text-ink-900">
            {session?.expiresAt ? new Date(session.expiresAt).toLocaleString() : '—'}
          </dd>
        </dl>
      </section>
    </div>
  );
}
